export default __webpack_public_path__ + "static/media/cube-grid.6f2d830a.less";